/**
公共请求类
ver 1.0.0
修改记录：
  2018-6-12：
    ssoRequest.getRequestParamter
    /rest/ezcomp/index/getCurrentSystem获取当前系统
    /rest/ezcomp/index/getCurrentOrganization 获取当前单位
    /rest/ezcomp/index/getCurrentTicket 获取当前系统凭证
    /rest/ezcomp/index/getCurrentToken 获取当前用户凭证
    /rest/ezcomp/index/getCurrentTrust 获取当前所属集团
*/
import Fingerprint2 from 'fingerprintjs2'
let ssoRequest = {
  requestUrl: {
    getTokenByTicket: 'rest/security/auth/getTokenByTicket',
    getCurrentToken: 'rest/ezcomp/index/getCurrentToken',
    getCurrentTicket: 'rest/ezcomp/index/getCurrentTicket',
    getCurrentOrganization: 'rest/ezcomp/index/getCurrentOrganization',
    getSolution: 'rest/ezcomp/index/getSolution', //为了解决域名代理问题获取系统信息：包括版权信息，系统图标
    getCurrentSystem: 'rest/ezcomp/index/getCurrentSystem', //获取当前系统信息：包括版权信息，系统图标
    getLatest: '/rest/main/index/latest', //获取子系统最新版本号
    getLimitations: 'rest/ezcomp/index/limitations', //获取是否有服务到期的提示信息
    getSystemOpenInfo: 'rest/ezcomp/index/getSystemOpenInfo', //获取是否有服务到期的提示信息
    getDeviceExpiry: 'rest/ezcomp/device/getDeviceExpiry', //设备校验
    getVersion: '/rest/main/index/getVersion ', //获取系统版本
  },
  ssoTokenKey: 'ssoToken',
  ticketIdKey: 'ticketId', //同域名下，要设置不同的变量
  ssoLoginUrl: '', //单点登录路径
  onlyOvertime: false, //判断是否已经有接口触发登录超时(防止超时弹窗多次弹出)
  hasRequiredTicket: true,
  systemCode: null,
}

import UrlUitls from './urlUitls.js'

//axios 请求前的拦截器
ssoRequest.axios = {
  interceptorsOfRequest_then: function (config) {
    // 在发送请求之前做些什么,添加token
    // console.log("axios.interceptors.request",config);
    // console.log("localStorage.ssoToken",localStorage.ssoToken);
    var ssoToken = sessionStorage.getItem(ssoRequest.ssoTokenKey)
    if (ssoToken) {
      //axios.defaults.headers.common['sso-token'] = localStorage.ssoToken;
      config.headers['sso-token'] = ssoToken
    }

    var ticketId = sessionStorage.getItem(ssoRequest.ticketIdKey)

    //特殊处理~ 表示去当前域名路径
    //~static/mock/crud/queryAdvance.json => static/mock/crud/queryAdvance.json
    if (config.url.charAt(0) == '~') {
      config.baseURL = ''
      config.url = config.url.substr(1)
    } else if (config.url.charAt(0) == '$') {
      //支持不拼接ticket
      if (!config.baseURL) config.baseURL = ''
      config.url = config.url.substr(1)
    } else {
      //支持多开窗口
      if (ticketId) {
        config.headers['sso-ticket'] = ticketId
        if (!config.baseURL) config.baseURL = ''
        config.baseURL = config.baseURL + 't/' + ticketId + '/'
      }
    }

    return config
  },
  interceptorsOfRequest_catch: function (error) {
    // 对请求错误做些什么
    return Promise.reject(error)
  },
  // 添加响应拦截器
  interceptorsOfResponse_then: function (response) {
    // 对响应数据做点什么
    return response
  },
  interceptorsOfResponse_catch: function (error) {
    if (error.response && error.response.status == '401') {
      // console.log("axios.interceptors.response.use=", error.response.status,
      //   error.response);
      sessionStorage.clear()
      if (!ssoRequest.onlyOvertime) {
        ssoRequest.onlyOvertime = true
        alert('用户登录已超时，需要重新登录')
        ssoRequest.gotoSSOLogin()
      }
      return Promise.reject(error)
    }
    // console.log("axios.interceptors.response.use=", error);
    return Promise.reject(error)
  },
}

//跳转到单点登录界面。
ssoRequest.gotoSSOLogin = function () {
  // debugger;
  sessionStorage.clear()
  if (!ssoRequest.ssoLoginUrl) {
    console.log('没有配置统一登录URL')
    alert('没有配置统一登录URL')
    return
  }
  var redirectUrl = encodeURIComponent(window.location)
  // let system = vue ? vue.$store.state.user.CurrentTicket : null

  if (ssoRequest.systemCode == 'PASSPORT') {
    window.location = ssoRequest.ssoLoginUrl
  } else {
    var tmpUrl = ssoRequest.systemCode
      ? ssoRequest.ssoLoginUrl.replace(/(systemCode=)[^&]*/, `$1${ssoRequest.systemCode}`)
      : ssoRequest.ssoLoginUrl
    tmpUrl += ssoRequest.ssoLoginUrl.indexOf('?') > -1 ? '&' : '?'
    tmpUrl += 'url=' + redirectUrl
    window.location = tmpUrl
  }
}

/**
    获取验证票据
    @method getTokenByTicket
    @param ticketId
    @param callback 回调方法
    @param {Object} config 预留扩展
    @return
*/
ssoRequest.getTokenByTicket = function (vue, ticketId, callback) {
  // console.log("getTokenByTicket.ticketId", ticketId);
  vue.$axios
    .get(ssoRequest.requestUrl.getTokenByTicket + '?ticketId=' + ticketId)
    .then((res) => {
      if (res.data.code == 400) {
        // vue.$pgMessage.confirm({
        //   "title": "提示",
        //   "content": res.data.msg,
        //   onOk: () => {
        //     // 选择确定
        //     ssoRequest.gotoSSOLogin();
        //   }
        // });
        //ux说将提示去掉直接跳转至登录界面
        ssoRequest.gotoSSOLogin(vue)
        return
      } else if (!vue.$cfn.ajax1.isOK(res, this)) {
        //ssoRequest.gotoSSOLogin();
        return
      }
      // console.log("getTokenByTicket", res.data);

      sessionStorage.setItem(ssoRequest.ticketIdKey, ticketId)
      sessionStorage.setItem(ssoRequest.ssoTokenKey, res.data.data)
      // sessionStorage.ticketId=ticketId;
      //缓存起来
      // sessionStorage.ssoToken=res.data.data;
      if (callback) {
        callback(res)
      }
    })
    .catch((res) => {
      //ssoRequest.gotoSSOLogin();
      vue.$cfn.ajax1.catch1(res, vue)
    })
}

/**
    获取当前用户组织信息
    @method getCurrentTicket
    @return
*/
;(ssoRequest.getCurrentTicket = function (vue) {
  ssoRequest.onlyOvertime = false
  vue.$axios
    .get(ssoRequest.requestUrl.getCurrentTicket)
    .then((res) => {
      vue.$store.commit('setCurrentTicket', res.data.data)
      ssoRequest.getLimitations(vue)
      ssoRequest.systemCode = res.data.data ? res.data.data.system.code : null
    })
    .catch(() => {
      return
    })
}),
  /**
    获取当前企业详细信息
    @method getCurrentOrganization
    @return
*/
  (ssoRequest.getCurrentOrganization = function (vue) {
    if (!ssoRequest.requestUrl.getCurrentOrganization) return false
    vue.$axios
      .get(ssoRequest.requestUrl.getCurrentOrganization)
      .then((res) => {
        vue.$store.commit('setOrganization', res.data.data)
      })
      .catch(() => {
        return
      })
  }),
  /**
    获取当前域名下得配置，包括当前系统版本号等信息
    @method getSolution
    @return
*/
  (ssoRequest.getSolution = function (vue) {
    if (vue.GLOBAL.baseURL.indexOf('passport') > -1) return
    var url = UrlUitls.getDomain(
      `${vue.GLOBAL.baseURL}${ssoRequest.requestUrl.getSolution}?prefix=${window.location.hostname}`
    )
    vue.$axios
      .get(url)
      .then((res) => {
        vue.$store.commit('setSolution', res.data.data)
        vue.$nextTick(() => {
          if (res.data && res.data.data) {
            let tempTitle = document.querySelector('title').innerHTML
            if (!tempTitle || tempTitle.indexOf('-') == -1) {
              document.querySelector('title').innerHTML = res.data.data.title + '-' + tempTitle
              var link =
                document.querySelector("link[rel*='icon']") || document.createElement('link')
              link.type = 'image/x-icon'
              link.rel = 'shortcut icon'
              link.href = res.data.data.favicon
              document.getElementsByTagName('head')[0].appendChild(link)
            }
          }
        })
      })
      .catch((res) => {
        vue.$cfn.ajax1.catch1(res, vue)
        return
      })
  }),
  /**
    获取当前系统详细信息详细信息
    @method getCurrentSystem
    @return
*/
  (ssoRequest.getCurrentSystem = function (vue) {
    if (vue.GLOBAL.baseURL.indexOf('passport') > -1) return
    vue.$axios
      .get(ssoRequest.requestUrl.getCurrentSystem)
      .then((res) => {
        vue.$store.commit('setSystem', res.data.data)
        // 目前信息均以solution为准此处暂时废弃
        //   vue.$nextTick(() => {
        //     if(res.data && res.data.data){
        //       let tempTitle = document.querySelector("title").innerHTML;
        //       if(!tempTitle || tempTitle.indexOf('-') == -1){
        //         document.querySelector("title").innerHTML = res.data.data.title + "-" + tempTitle;
        //         var link = document.querySelector("link[rel*='icon']") || document.createElement('link');
        //         link.type = 'image/x-icon';
        //         link.rel = 'shortcut icon';
        //         link.href = res.data.data.favicon;
        //         document.getElementsByTagName('head')[0].appendChild(link);
        //       }
        //     }
        //   })
      })
      .catch(() => {
        return
      })
  }),
  /**
    获取当前子系统内部版本号
    @method getLatest
    @return
*/
  (ssoRequest.getLatest = function (vue) {
    vue.$axios
      .get(ssoRequest.requestUrl.getLatest)
      .then((res) => {
        vue.$store.commit('setLatestVasion', res.data.data)
      })
      .catch(() => {
        return
      })
  }),
  /**
    获取是否有服务到期的提示信息
    @method getLimitations
    @return
    SUCCESS(code:200, msg:'')
    WARN(code:201, msg:'您有服务即将到期')
    EXPIRE(code:202, msg:'您有服务已过期')
    INVALID(code:203, msg:'无效期')
*/
  (ssoRequest.getLimitations = function (vue) {
    if (vue.GLOBAL.baseURL.indexOf('passport') > -1) return
    let system = vue ? vue.$store.state.user.CurrentTicket : null
    let systemCode = system ? system.system.code : 'ISCC'
    vue.$axios
      .get(ssoRequest.requestUrl.getLimitations + `?systemCode=${systemCode}`)
      .then((res) => {
        if (res.data.data.code == '201') {
          vue.$Message.warning({
            content: res.data.data.msg,
            duration: 0,
            closable: true,
          })
        } else if (res.data.data.code == '202') {
          vue.$Message.warning({
            content: res.data.data.msg,
            duration: 0,
            closable: true,
          })
        } else if (res.data.data.code == '203') {
          vue.$Message.error({
            content: res.data.data.msg,
            duration: 0,
            closable: true,
          })
        }
      })
      .catch(() => {
        return
      })
  }),
  /**
    获取策略
    @method strategy
*/
  (ssoRequest.getStrategy = function (vue) {
    // console.log("strategy", ssoRequest.requestUrl.strategyUrl);
    if (!ssoRequest || !ssoRequest.requestUrl || !ssoRequest.requestUrl.strategyUrl) return
    vue.$axios
      .get(ssoRequest.requestUrl.strategyUrl)
      .then((res) => {
        // console.log("strategy:res", res.data.data);
        if (res.data.code == 200) {
          vue.$store.commit('setStrategy', res.data.data)
        }
      })
      .catch((res) => {
        //ssoRequest.gotoSSOLogin();
        // console.log("strategy.res", res);
        vue.$cfn.ajax1.catch1(res, vue)
      })
  })

/**
    获取当前系统开放时间 有效期：2020-12-13 至 2021-12-13
    @method SystemOpenInfo 
*/
ssoRequest.getSystemOpenInfo = function (vue) {
  if (!ssoRequest || !ssoRequest.requestUrl || !ssoRequest.requestUrl.getSystemOpenInfo) return
  vue.$axios
    .get(ssoRequest.requestUrl.getSystemOpenInfo)
    .then((res) => {
      if (res.data.code == 200) {
        vue.$store.commit('setSystemOpenInfo', res.data.data)
      }
    })
    .catch((res) => {
      vue.$cfn.ajax1.catch1(res, vue)
    })
}

/**
    获取当前系统开放时间 有效期：2020-12-13 至 2021-12-13
    @method SystemOpenInfo 
*/
ssoRequest.getVersion = function (vue) {
  if (vue.GLOBAL.baseURL.indexOf('union') == -1 && vue.GLOBAL.baseURL.indexOf('link') == -1) return
  if (!ssoRequest || !ssoRequest.requestUrl || !ssoRequest.requestUrl.getVersion) return
  vue.$axios
    .get(ssoRequest.requestUrl.getVersion)
    .then((res) => {
      if (res.data.code == 200) {
        vue.$store.commit('setVersion', res.data.data)
      }
    })
    .catch((res) => {
      vue.$cfn.ajax1.catch1(res, vue)
    })
}

/**
    获取当前用户凭证
    @method getCurrentToken
    @param callback 回调方法
    @param {Object} config 预留扩展
    @return
*/
ssoRequest.getCurrentToken = function (vue, callback) {
  // console.log("getCurrentToken", ssoRequest.requestUrl.getCurrentToken);
  vue.$axios
    .get(ssoRequest.requestUrl.getCurrentToken)
    .then((res) => {
      // console.log("getCurrentToken:res", res.data.data);
      if (!vue.$cfn.ajax1.isOK(res, this)) {
        ssoRequest.gotoSSOLogin(vue)
        return
      }
      vue.$store.commit('setUser', res.data.data)
      //解决频繁请求浪费资源问题
      if (ssoRequest.hasRequiredTicket) {
        ssoRequest.getCurrentTicket(vue)
        ssoRequest.getStrategy(vue)
        ssoRequest.getCurrentOrganization(vue)
        ssoRequest.getSolution(vue)
        ssoRequest.getCurrentSystem(vue)
        ssoRequest.getSystemOpenInfo(vue)
        ssoRequest.getVersion(vue)
        //   ssoRequest.getLatest(vue);
        ssoRequest.hasRequiredTicket = false
      }

      if (callback) {
        callback(res)
      }
    })
    .catch((res) => {
      //ssoRequest.gotoSSOLogin();
      // console.log("getCurrentToken.res", res);
      vue.$cfn.ajax1.catch1(res, vue)
    })
}

/**
    检查授权是否有效
    @method getCurrentToken
    @param callback 回调方法
    @param {Object} config 预留扩展
    @return
*/
ssoRequest.checkAuth = function (vue, callback) {
  // console.log("checkAuth");
  //已有token，表明票据已被使用。直接用token获取
  var ssoToken = sessionStorage.getItem(ssoRequest.ssoTokenKey)

  var ticketIdOfStoreage = sessionStorage.getItem(ssoRequest.ticketIdKey)

  let param = UrlUitls.getRequestParamter()
  // console.log("param", param);
  let ticketId = param.ticket

  if (ssoToken && ticketIdOfStoreage) {
    //条件：直接获取用户。1.param.ticket 不传则  。2.param.ticket=ticketIdOfStoreage

    //缓存ticket与参数不同，表明需要重新获取token
    if (!param.ticket || ticketIdOfStoreage == param.ticket) {
      ssoRequest.getCurrentToken(vue, callback)
      return
    }
  }

  //

  if (!ticketId) {
    ssoRequest.gotoSSOLogin(vue)
    return
  }
  ssoRequest.getTokenByTicket(vue, ticketId, () => {
    ssoRequest.getCurrentToken(vue, callback)
  })
}

/**
 * 检查是否更好设备登录，更换设备后需要手机好校验
 * @param {*} obj
 * @returns GLOBAL
 */
ssoRequest.deviceExpiry = function (vue) {
  return new Promise((resolve) => {
    Fingerprint2.get(function (components) {
      const values = components.map(function (component, index) {
        if (index === 0) {
          //把微信浏览器里UA的wifi或4G等网络替换成空,不然切换网络会ID不一样
          return component.value.replace(/\bNetType\/\w+\b/, '')
        }
        return component.value
      })
      // 生成最终id murmur
      const murmur = Fingerprint2.x64hash128(values.join(''), 31)
      vue.$axios
        .post(ssoRequest.requestUrl.getDeviceExpiry, {
          fingerprint: murmur,
          content: JSON.stringify(components),
        })
        .then((res) => {
          if (res?.data?.data?.expiry) {
            vue.$pgMessage.confirm({
              content: res?.data?.msg,
              closable: false,
              maskClosable: false,
              onOk() {
                const temUrl = `${vue.GLOBAL.checkDeviceUrl}?device=${res?.data?.data?.device}`
                var win1 = window.open(temUrl)
                if (!win1 || !win1.location) {
                  vue.$Message.error('被浏览器拦截了，请设置浏览器允许弹出窗口！')
                }
                resolve('deviceExpiry')
              },
            })
          } else {
            resolve(false)
          }
        })
    })
  })
}

/**
 * 获取ssoToken
 */
ssoRequest.getToken = function (obj) {
  const ssoToken = sessionStorage.getItem(obj.ssoTokenKey)
  return ssoToken
}
/**
 * 获取ticketId
 */

ssoRequest.getTicketId = function (obj) {
  const ticketId = sessionStorage.getItem(obj.ticketIdKey)
  return ticketId
}

export default ssoRequest
